module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/point01-9db691a9e2e4630362bd042e823b400b.png";